import { useMediaQuery } from "@mui/material";
import { mobileQuery } from "../config";

export function useIsMobile() {
	return useMediaQuery(mobileQuery);
}
